import { Component, OnInit, Input } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { APP_LANGUAGE } from '../../enums';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements OnInit {
  @Input() isTitleVisible: boolean = true;
  @Input() isNameVisible: boolean = true;
  @Input() isNameShort: boolean = true;
  @Input() isMobileMenu: boolean = false;

  protected readonly APP_LANGUAGE = APP_LANGUAGE;
  currentLang = this.languageService.getCurrentLanguage();
  isMenuOpen: boolean = false;

  constructor(private readonly languageService: LanguageService) {}

  ngOnInit(): void {}

  changeLanguage(lang: APP_LANGUAGE) {
    this.currentLang = lang;
    this.languageService.setLanguage(lang);
  }

  openMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  clickedOutside() {
    this.isMenuOpen = false;
  }
}
